import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button } from "@cirrus/ui-kit-ts/src/components/atoms/Button"

import { useCustomerInfo } from "../../../CustomerInfo/context"
import { AlternativeLoginButtons } from "../../containers/AlternativeLoginButtons"
import { useNavigationService } from "../../providers/NavigationService"

const LOGIN_WITH_KEYCODE_BTN_ID = "login-with-keycode-btn-id"
const LOGIN_WITH_USERNAME_BTN_ID = "login-with-username-btn-id"

export const AlternativeLoginForSaml = () => {
  const { i18n } = useTranslations()
  const { navigate } = useNavigationService()
  const { data } = useCustomerInfo()

  return <AlternativeLoginButtons>
    <Button
      id={LOGIN_WITH_USERNAME_BTN_ID}
      label={`${i18n("Account.Login:LoginWith")} ${i18n("Login:Username")}`}
      variant="outlined" onClick={() => navigate("/login")}/>

    {!!data?.keycode && <Button type="button"
                                id={LOGIN_WITH_KEYCODE_BTN_ID}
                                label={`${i18n("Account.Login:LoginWith")} ${i18n("Account.Login:Keycode")}`}
                                variant="outlined" onClick={() => navigate("/keycode")}/>}
  </AlternativeLoginButtons>
}
